/* eslint-disable */
import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Box, Button, Grid, Paper, TextField } from '@mui/material';
import {
  backLabelStyle,
  btnStyle,
  btnStyleActive,
  checkListStyle,
  forgotHeaderStyle,
  h2Style,
  inputStyle,
  labelStyle,
  paperStyle,
  pLabelDarkerStyle,
  pLabelStyle,
  pStyle,
} from '../styles';
import { AuthContext } from '../../contexts/authContext';
import { useValidPasswordAdvance } from '../../hooks/useValidPasswordAdvance';
import { useValidCode } from '../../hooks/useValidCode';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { IconButton, InputAdornment, Typography } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { PasswordType } from '../../interfaces/IPassType';
import { IUserAuth } from '../../interfaces/IUserAuth';
import { AuthPAGES } from '../../constants/pages';
import { Notif } from '../../components/Snackbar/Snackbar';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Header } from '../../components/Header/Header';
import { MuiButton } from '../../components/Button/Button';
import KeyIcon from '@mui/icons-material/Key';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import { useAppSelector, useAppDispatch } from '../../../../hooks/reduxHooks';
import DeleteAccountConfirmation from '../../../../../florence/screens/SubscriptionScreen/Modals/DeleteAccountConfirmation';
import florenceApi, {
  useDeleteUserAccountMutation,
} from '../../../../../common/apis/FlorenceApi';
import SnackbarUtils from '../../../../../common/utils/SnackbarUtilsConfigurator';

type styleProps = {
  top?: string;
  position?: string;
};

const CheckPassword: React.FC<styleProps> = (props) => {
  /* States and context declaration */
  const dispatch = useAppDispatch();
  const { passwordAdvance, setPasswordAdvance, passwordAdvanceIsValid } =
    useValidPasswordAdvance(null);
  const [confirmPass, setConfirmPass] = useState('');
  const [confirmPassError, setConfirmPassError] = useState('');
  const [open, setOpen] = React.useState(false);
  const [showPassword, setshowPassword] = useState<boolean>(false);
  const [showCPassword, setshowCPassword] = useState<boolean>(false);
  const [showCurrentPassword, setshowCurrentPassword] =
    useState<boolean>(false);
  const { code, setCode, codeIsValid } = useValidCode(null);
  const [inProgress, setInProgress] = useState<boolean>(false);

  const authContext = useContext(AuthContext);
  const [currentPassword, setCurrentPassword] = React.useState('');
  const { type }: any = useParams();
  const { name, email, stateLocation } = authContext;
  const { user } = useAppSelector((state) => state.model);
  const [genericErrorMessage, setGenericErrorMessage] = useState('');
  const [showDeleteAccountConfirmation, setShowDeleteAccountConfirmation] =
    React.useState(false);
  const [deleteUserAccount, { isLoading }] = useDeleteUserAccountMutation();
  const navigate = useNavigate();

  useEffect(() => {
    onComparePassword(confirmPass);
  }, [confirmPass, passwordAdvance]);

  const deleteAccount = async () => {
    try {
      const accessToken = localStorage.getItem('accessToken');
      if (!!!accessToken) return;
      const payload = await deleteUserAccount(accessToken).unwrap();
      showDeletionStatusAlert(payload.message, payload.success);
    } catch (error: any) {
      if (error.message) {
        SnackbarUtils.error(error.message);
      }
    }
  };

  const showDeletionStatusAlert = (message: string, success: boolean) => {
    if (success) {
      SnackbarUtils.success(message);
      authContext.signOut();
      navigate(AuthPAGES.signIn);
      dispatch(florenceApi.util.resetApiState());
      localStorage.clear();
    } else {
      SnackbarUtils.error(message);
    }
  };

  const onComparePassword = (confirmPass: string) => {
    setConfirmPass(confirmPass);
    if (confirmPass === '') {
      setConfirmPassError('');
      return;
    }
    if (confirmPass !== passwordAdvance) {
      setConfirmPassError(
        'The passwords you have entered don’t match, please correct to proceed'
      );
    } else {
      setConfirmPassError('Passwords match');
    }
  };

  const onNextPressed = async (e: any) => {
    e.stopPropagation();
    setInProgress(true);
    if (type === PasswordType.RECOVERY) {
      try {
        await authContext.forgotPassword(email, code, passwordAdvance);
        navigate(AuthPAGES.signIn);
      } catch (error: any) {
        setGenericErrorMessage(`An error ocurred: ${error.message}`);
        setOpen(true);
        setInProgress(false);
      }
    } else if (type === PasswordType.CHANGE) {
      if (!currentPassword || !passwordAdvance) return;
      authContext.getSession().then((res: any) => {
        authContext
          .changePassword(currentPassword, passwordAdvance)
          .then((res: any) => {
            setGenericErrorMessage('Your new password has been set!');
            setOpen(true);
            setInProgress(false);
            setTimeout(() => {
              navigate(-1);
            }, 1000);
          })
          .catch((error: any) => {
            console.log(error);
            setGenericErrorMessage(error.message);
            setOpen(true);
            setInProgress(false);
          });
      });
    } else {
      if (name && email && passwordAdvance && stateLocation)
        try {
          const userAuth: IUserAuth = {
            username: email,
            password: passwordAdvance,
            phone_number: '',
            email: email,
            name: name,
            state: stateLocation,
          };
          await authContext.signUpWithPhone(userAuth);
          authContext.setPasswordAdvance(passwordAdvance);
          navigate(AuthPAGES.verifyEmail);
        } catch (error: any) {
          console.log(error);
          setGenericErrorMessage(error.message);
          setOpen(true);
          setInProgress(false);
        }
    }
  };

  const handleClickShowPassword = () => {
    setshowPassword(!showPassword);
  };

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const handleClickShowCPassword = () => {
    setshowCPassword(!showCPassword);
  };

  const handleMouseDownCPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const handleClickShowCurrentPassword = () => {
    setshowCurrentPassword(!showCurrentPassword);
  };

  const handleMouseDownCurrentPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const isButtonDisabled = () => {
    return (
      passwordAdvanceIsValid[0].text !== 'Password Strength: Good' ||
      confirmPassError !== 'Passwords match' ||
      inProgress
    );
  };

  const onRecoverPressed = async (e: any) => {
    e.stopPropagation();
    if (email) {
      try {
        await authContext.sendCodeRecoverPassword(email);
        setGenericErrorMessage('Link sent successfully');
        setOpen(true);
      } catch (error: any) {
        setGenericErrorMessage(error.message);
        setOpen(true);
      }
    }
  };

  return (
    <Grid
      container
      justifyContent='center'
      alignContent='center'
      style={{
        display: 'flex',
        flexDirection: 'column',
        top: props.top ? props.top : '',
        position: props.position ? (props.position as any) : undefined,
      }}
    >
      <Grid item xl={4} lg={4} md={5} sm={6} xs={12}>
        <Paper elevation={0} style={paperStyle}>
          <Grid item xs={12} md={12} xl={12} style={forgotHeaderStyle}>
            <Header
              text1={
                type === PasswordType.RECOVERY
                  ? 'Create new password'
                  : type === PasswordType.CHANGE
                  ? 'Change Password'
                  : 'Create Password'
              }
              text2={
                type === PasswordType.CHANGE
                  ? 'Your new password must be different from previous used passwords'
                  : 'Must be at least 8 characters'
              }
            />
          </Grid>
          {type === PasswordType.RECOVERY ? (
            <Grid item xs={12} md={12} xl={12}>
              <TextField
                size='small'
                variant='outlined'
                fullWidth
                style={{ ...inputStyle, marginTop: '0px' }}
                type='text'
                value={code}
                onChange={(e: any) => setCode(e.target.value)}
                label='Enter Confirmation Code'
                InputProps={{
                  style: { borderRadius: '50px' },
                  startAdornment: (
                    <InputAdornment position='start'>
                      <KeyIcon style={{ color: '#227BEF', width: '20px' }} />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          ) : null}
          {type === PasswordType.CHANGE ? (
            <Grid item xs={12} md={12} xl={12}>
              <TextField
                disabled
                value={user?.email}
                size='small'
                variant='outlined'
                fullWidth
                style={{ ...inputStyle, marginBottom: '12px' }}
                InputProps={{
                  style: { borderRadius: '50px' },
                  startAdornment: (
                    <InputAdornment position='start'>
                      <EmailOutlinedIcon
                        style={{
                          color: genericErrorMessage !== '' ? 'red' : '#227BEF',
                          width: '20px',
                        }}
                      />
                    </InputAdornment>
                  ),
                }}
                placeholder='E-mail'
              />
              <TextField
                size='small'
                variant='outlined'
                fullWidth
                style={{ ...inputStyle, marginTop: '0px' }}
                type={showCurrentPassword ? 'text' : 'password'}
                value={code}
                onChange={(e: any) => setCurrentPassword(e.target.value)}
                label='Enter your current password'
                InputProps={{
                  style: { borderRadius: '50px' },
                  startAdornment: (
                    <InputAdornment position='start'>
                      <KeyIcon style={{ color: '#227BEF', width: '20px' }} />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position='end'>
                      <IconButton
                        onClick={handleClickShowCurrentPassword}
                        onMouseDown={handleMouseDownCurrentPassword}
                        edge='end'
                      >
                        {showCurrentPassword ? (
                          <VisibilityOff />
                        ) : (
                          <Visibility />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          ) : null}
          <Grid item xs={12} md={12} xl={12}>
            <TextField
              size='small'
              label='New Password'
              fullWidth
              variant='outlined'
              style={{
                ...inputStyle,
                marginTop: type === PasswordType.RECOVERY ? '12px' : '12px',
              }}
              type={showPassword ? 'text' : 'password'}
              value={passwordAdvance}
              onChange={(e: any) => setPasswordAdvance(e.target.value)}
              InputProps={{
                style: { borderRadius: '50px' },
                startAdornment: (
                  <InputAdornment position='start'>
                    <LockOutlinedIcon
                      style={{ color: '#227BEF', width: '20px' }}
                    />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position='end'>
                    <IconButton
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge='end'
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} md={12} xl={12}>
            <TextField
              size='small'
              variant='outlined'
              label='Confirm New Password'
              fullWidth
              style={inputStyle}
              type={showCPassword ? 'text' : 'password'}
              value={confirmPass}
              onChange={(e: any) => setConfirmPass(e.target.value)}
              InputProps={{
                style: { borderRadius: '50px' },
                startAdornment: (
                  <InputAdornment position='start'>
                    <LockOutlinedIcon
                      style={{ color: '#227BEF', width: '20px' }}
                    />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position='end'>
                    <IconButton
                      aria-label='toggle password visibility'
                      onClick={handleClickShowCPassword}
                      onMouseDown={handleMouseDownCPassword}
                      edge='end'
                    >
                      {showCPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} md={12} xl={12} style={checkListStyle}>
            {passwordAdvanceIsValid
              ? passwordAdvanceIsValid.map((item: any, index: number) => {
                  if (item.text)
                    return (
                      <p
                        style={{
                          ...pStyle,
                          display: 'flex' as any,
                          alignItems: 'center' as any,
                        }}
                        key={index}
                      >
                        {item.active ? (
                          <CheckCircleIcon style={{ width: '18px' }} />
                        ) : (
                          <CheckCircleOutlineIcon style={{ width: '18px' }} />
                        )}
                        {item.text}
                      </p>
                    );
                })
              : null}
          </Grid>
          <Grid item xs={12} md={12} xl={12}>
            <MuiButton
              loading={inProgress}
              disabled={isButtonDisabled()}
              hasNoImage={type === PasswordType.CHANGE ? true : false}
              customStyle={
                type === PasswordType.CHANGE
                  ? {
                      ...btnStyle,
                      backgroundColor: isButtonDisabled()
                        ? '#868686'
                        : '#227BEF',
                      borderRadius: '15px',
                    }
                  : undefined
              }
              text={
                type === PasswordType.RECOVERY || type === PasswordType.CHANGE
                  ? 'Reset password'
                  : 'Register Now'
              }
              onSubmit={onNextPressed}
            />
            <Box
              className='row'
              sx={{
                justifyContent: 'center',
                alignItems: 'center',
                mt: 12,
                visibility: type === PasswordType.CHANGE ? 'visible' : 'hidden',
              }}
            >
              <Button
                onClick={() => setShowDeleteAccountConfirmation(true)}
                variant='text'
                color='error'
              >
                <Typography>Delete Account</Typography>
              </Button>
            </Box>
            <DeleteAccountConfirmation
              open={showDeleteAccountConfirmation}
              onClose={() => setShowDeleteAccountConfirmation(false)}
              onAccept={deleteAccount}
              loading={isLoading}
            />
          </Grid>
          <Grid item xs={12} md={12} xl={12} style={labelStyle}>
            {type !== PasswordType.CHANGE ? (
              <Typography style={pLabelDarkerStyle}>
                Have an account?
                <Link
                  to={AuthPAGES.signIn}
                  style={{ ...pLabelStyle, marginLeft: '5px' }}
                >
                  Sign in
                </Link>
              </Typography>
            ) : null}
          </Grid>
          {/* <Grid item xs={12} md={12} xl={12} style={backLabelStyle}>
            <Link style={pLabelStyle} to="" onClick={(e: any) => navigate(-1)}>
              Back
            </Link>
          </Grid> */}
        </Paper>
        <Grid
          item
          xs={12}
          md={12}
          xl={12}
          style={{ ...labelStyle, marginTop: '40px' }}
        >
          {type !== PasswordType.SIGNUP ? (
            <Typography style={{ ...pLabelDarkerStyle, color: 'white' }}>
              Did not receive the email? Check your spam filter or
              <Link
                to=''
                onClick={onRecoverPressed}
                style={{ ...pLabelStyle, marginLeft: '5px', color: 'white' }}
              >
                Send link again
              </Link>
            </Typography>
          ) : null}
        </Grid>
      </Grid>
      <Notif open={open} setOpen={setOpen} message={genericErrorMessage} />
    </Grid>
  );
};

export default CheckPassword;
